/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Meta_TitleInputs */

const es_privacy_policy_meta_title = /** @type {(inputs: Privacy_Policy_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata | Politica de Privacidad`)
};

const en_privacy_policy_meta_title = /** @type {(inputs: Privacy_Policy_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata | Privacy Policy`)
};

/**
* | output |
* | --- |
* | "Nexata \| Privacy Policy" |
*
* @param {Privacy_Policy_Meta_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_meta_title = /** @type {((inputs?: Privacy_Policy_Meta_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Meta_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_meta_title(inputs)
	return en_privacy_policy_meta_title(inputs)
});
export { privacy_policy_meta_title as "privacy_policy.meta.title" }